export default {"src":"/_next/static/media/icon-precisely-controlled.19d3db29.svg","height":26,"width":27,"blurWidth":0,"blurHeight":0};